import React from 'react';
import { ArrowRight } from 'lucide-react';

const WelcomePage = ({ next }) => {
  return (
    <>
      <div className="text-center mb-5">
        <h1 className="text-2xl font-bold mb-3 bg-gradient-to-r from-blue-600 to-indigo-700 inline-block text-transparent bg-clip-text">CareerFit™ 职业倾向测试</h1>
        <p className="text-gray-600 text-base max-w-lg mx-auto mb-3">
          欢迎来到Careers Compass打造的职业倾向测试问卷。
        </p>
        <p className="text-gray-600 text-sm max-w-lg mx-auto mb-3">
          这份问卷是为了帮助你更好地了解自己，找到最适合自己的职业方向。回答时请你<span className="font-bold">尽量回忆过去真实的行为与反应来作答</span>，而不是理想版自我或"应该怎样"的答案。
        </p>
      </div>
      
      <div className="space-y-3 mb-6">
        <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
          <p className="text-gray-700 flex items-start text-sm">
            <span className="text-blue-500 mr-2 mt-0.5 flex-shrink-0">👉</span>
            <span>如果用"理想的自己"来作答，最终结果可能会有很大偏差，反而找不到最适合自己的路径。</span>
          </p>
        </div>
        
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
          <h3 className="text-blue-600 text-base font-medium mb-1">完成时间</h3>
          <p className="text-gray-600 text-sm">整个问卷需要不少于<span className="font-bold">20-30分钟</span>，建议找一个合适的时间、可以深度自我思考的时间一次性完成。</p>
        </div>
      </div>
      
      <button 
        onClick={next}
        className="w-full flex items-center justify-center p-3 rounded-lg bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-400 hover:to-indigo-500 transition-all duration-300 text-white font-medium group shadow-md hover:shadow-lg"
      >
        开始评估
        <ArrowRight size={16} className="ml-2 transition-transform duration-300 transform group-hover:translate-x-1" />
      </button>
    </>
  );
};

export default WelcomePage;